import { z } from 'zod';

const workflowListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  isArchived: z.boolean(),
});

export const workflowListingResponseSchema = z.object({
  items: z.array(workflowListItemSchema),
  nextPage: z.number().optional(),
});

export const entityOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const triggerDataResponseSchema = z.record(z.string(), z.array(entityOptionSchema));

export const createWorkflowResponseSchema = z.object({
  id: z.string(),
});

const workflowGraphIdNameRefUiSchema = z.object({
  value: z.string(),
  label: z.string(),
});

const enrollBranchOfficeRuleSchema = z.object({
  key: z.literal('branchOfficeIds'),
  value: z.array(workflowGraphIdNameRefUiSchema).min(1),
  condition: z.literal('equal'),
});

const enrollJobTypeRuleSchema = z.object({
  key: z.literal('jobTypeIds'),
  value: z.array(workflowGraphIdNameRefUiSchema).min(1),
  condition: z.literal('equal'),
});

const enrollRuleConditionSchema = z.union([enrollBranchOfficeRuleSchema, enrollJobTypeRuleSchema]);

const enrollRuleAndSchema = z.object({
  AND: z.array(enrollRuleConditionSchema).min(1, 'AND must contain at least one condition'),
});

const enrollRuleOrSchema = z.object({
  OR: z.array(enrollRuleAndSchema).min(1, 'OR must contain at least one element'),
});

const enrollNodeSchema = z.object({
  id: z.string().min(1),
  type: z.literal('enroll'),
  rules: enrollRuleOrSchema,
});

const waitNodeRulesFullSchema = z.object({
  key: z.literal('percentage'),
  value: z.coerce.number().min(0).max(100),
  condition: z.literal('greaterThan'),
});

const waitNodeSchema = z.object({
  id: z.string().min(1),
  type: z.literal('wait'),
  rules: waitNodeRulesFullSchema,
});

const actionNodeRulesFlatSchema = z.object({});

const actionNodeSchema = z.object({
  id: z.string().min(1),
  type: z.literal('action'),
  rules: actionNodeRulesFlatSchema,
});

const workflowNodeSchema = z.discriminatedUnion('type', [
  enrollNodeSchema,
  waitNodeSchema,
  actionNodeSchema,
]);

export const workflowDetailsResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  graph: z.array(workflowNodeSchema),
});

export type WorkflowListingResponse = z.infer<typeof workflowListingResponseSchema>;
export type TriggerDataResponse = z.infer<typeof triggerDataResponseSchema>;
export type CreateWorkflowResponse = z.infer<typeof createWorkflowResponseSchema>;
export type WorkflowDetailsResponse = z.infer<typeof workflowDetailsResponseSchema>;
